<template>
  <component v-bind:is="loaderComponent" />
</template>

<script>

import { getResultLoader } from '@/base/utils/load'

export default {
  name: 'ResultLoader',
  computed: {
    loaderComponent: function () {
      return this.load
    }
  },
  methods: {
    load () {
      return getResultLoader()
    }
  }
}
</script>
